/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: block;
}
:host .container {
  background-color: var(--calcite-color-foreground-1);
  box-shadow: 0 0 0 1px var(--calcite-color-border-2);
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  block-size: 100%;
  max-inline-size: 300px;
  padding: 0.75rem;
  position: relative;
  vertical-align: top;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}
:host .container.checked {
  z-index: var(--calcite-z-index);
  box-shadow: 0 0 0 1px var(--calcite-color-brand);
}
:host .container.heading-only {
  align-items: center;
}
:host .container:not(.input-enabled) ::slotted(calcite-checkbox),
:host .container:not(.input-enabled) ::slotted(calcite-radio-button) {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
:host .container.focused {
  outline-color: transparent;
}
:host .container.focused:not(.disabled):not(.input-enabled) {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
  outline-offset: -4px;
  box-shadow: 0 0 0 1px var(--calcite-color-brand), inset 0 0 0 2px var(--calcite-color-foreground-1);
}
:host .container.input-enabled.input-alignment-start.width-auto.heading-only, :host .container.input-enabled.input-alignment-start.width-auto.icon-only, :host .container.input-enabled.input-alignment-start.width-auto.description-only, :host .container.input-enabled.input-alignment-start.width-auto.heading.description, :host .container.input-enabled.input-alignment-start.width-auto.icon.description, :host .container.input-enabled.input-alignment-start.width-auto.heading.icon.description {
  display: inline-grid;
  grid-template-columns: max-content 1fr;
}
:host .container.input-enabled.input-alignment-start.heading-only, :host .container.input-enabled.input-alignment-start.icon-only, :host .container.input-enabled.input-alignment-start.description-only, :host .container.input-enabled.input-alignment-start.heading.description, :host .container.input-enabled.input-alignment-start.icon.description, :host .container.input-enabled.input-alignment-start.heading.icon.description {
  gap: 0.75rem;
}
:host .container.input-enabled.input-alignment-start .tile {
  order: 1;
}
:host .container.input-enabled.input-alignment-start.large-visual ::slotted(calcite-checkbox),
:host .container.input-enabled.input-alignment-start.large-visual ::slotted(calcite-radio-button) {
  position: absolute;
  inset-block-start: 0.75rem;
  inset-inline-start: 0.75rem;
}
:host .container.input-enabled.input-alignment-end.width-auto.heading-only, :host .container.input-enabled.input-alignment-end.width-auto.icon-only {
  display: inline-grid;
  grid-gap: 0.75rem;
  grid-template-columns: max-content 1fr;
}
:host .container.input-enabled.input-alignment-end.heading-only, :host .container.input-enabled.input-alignment-end.icon-only {
  gap: 0.75rem;
}
:host .container.input-enabled.input-alignment-end.description-only ::slotted(calcite-checkbox),
:host .container.input-enabled.input-alignment-end.description-only ::slotted(calcite-radio-button), :host .container.input-enabled.input-alignment-end.heading.description ::slotted(calcite-checkbox),
:host .container.input-enabled.input-alignment-end.heading.description ::slotted(calcite-radio-button), :host .container.input-enabled.input-alignment-end.icon.description ::slotted(calcite-checkbox),
:host .container.input-enabled.input-alignment-end.icon.description ::slotted(calcite-radio-button), :host .container.input-enabled.input-alignment-end.heading.icon.description ::slotted(calcite-checkbox),
:host .container.input-enabled.input-alignment-end.heading.icon.description ::slotted(calcite-radio-button) {
  position: absolute;
  inset-block-start: 0.75rem;
  inset-inline-end: 0.75rem;
}
:host .container.input-enabled.input-alignment-end.large-visual ::slotted(calcite-checkbox),
:host .container.input-enabled.input-alignment-end.large-visual ::slotted(calcite-radio-button) {
  position: absolute;
  inset-block-start: 0.75rem;
  inset-inline-end: 0.75rem;
}
:host .container.width-full {
  display: flex;
  max-inline-size: none;
}
:host .container.width-full .tile {
  flex: 1 1 auto;
}

.tile {
  pointer-events: none;
  box-sizing: border-box;
  display: flex;
  -webkit-user-select: none;
          user-select: none;
  flex-direction: column;
  gap: 0.5rem;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-3);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.tile-content-container {
  display: flex;
  inline-size: 100%;
  align-items: stretch;
  padding: 0px;
  color: var(--calcite-color-text-2);
  outline-color: transparent;
}

.tile-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.5rem;
  inline-size: 10%;
}

.tile-heading {
  pointer-events: none;
  overflow-wrap: break-word;
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-2);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.tile-description {
  pointer-events: none;
  overflow-wrap: break-word;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
  color: var(--calcite-color-text-3);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.tile--large-visual {
  display: grid;
  justify-content: center;
  text-align: center;
  min-block-size: 12rem;
}
.tile--large-visual .icon {
  align-self: flex-end;
}
.tile--large-visual calcite-icon {
  block-size: 64px;
  inline-size: 64px;
}
.tile--large-visual .tile-content-container {
  align-self: center;
}

:host(:hover) .container:not(.input-enabled) {
  box-shadow: 0 0 0 1px var(--calcite-color-brand);
}

:host(:hover) .tile-heading,
.checked .tile-heading {
  color: var(--calcite-color-text-1);
}
:host(:hover) .tile-description,
.checked .tile-description {
  color: var(--calcite-color-text-2);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}